class TopBarCountdown extends HTMLElement {
  constructor() {
    super();

    if (cookies.getCookie('topbar_countdown')) {
      this.removeTopbar();

      return;
    }

    this.closeButtons = this.querySelectorAll('button');
    this.bindEvents();
  }

  bindEvents() {
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.removeTopbar();
      });
    });
  }

  removeTopbar() {
    this.remove();
    document.body.style.setProperty('--header-height', `${document.querySelector('header-navigation').clientHeight}px`);
    cookies.setCookie('topbar_countdown', 'false', 1);
  }
}

customElements.define('top-bar-countdown', TopBarCountdown);
